export default class SocialConnect {
  static init() {
    const buttons = Array.from(
      document.querySelectorAll('.social-connect__link--iframe')
    );
    if (buttons.length > 0) {
      this.openInNewTabs(buttons);
    }
  }

  static openInNewTabs(buttons) {
    buttons.forEach(button =>
      button.addEventListener('click', event => {
        event.preventDefault();

        window.authIframeCallback = () =>
          (window.location = '/iframe-callback');
        window.open(button.href, '_blank');
      })
    );
  }
}
